// extracted by mini-css-extract-plugin
export var filterIncDec = "_bh-0";
export var leftBorder = "_bh-1";
export var rightBorder = "_bh-2";
export var stringInput = "_bh-3";